"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var Container = _styledComponents["default"].div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1sv3f3m-0"
})(["", ".spinner{animation:rotator 2s linear infinite;}@keyframes rotator{0%{transform:rotate(0deg);}100%{transform:rotate(270deg);}}", ".path{stroke-dasharray:187;stroke-dashoffset:0;transform-origin:center;animation:dash 2s ease-in-out infinite,colors 8s ease-in-out infinite;}@keyframes colors{0%{stroke:", ";}25%{stroke:", ";}50%{stroke:", ";}75%{stroke:", ";}100%{stroke:", ";}}@keyframes dash{0%{stroke-dashoffset:187;}50%{stroke-dashoffset:46;transform:rotate(135deg);}100%{stroke-dashoffset:187;transform:rotate(450deg);}}"], Container, Container, (0, _themeGet["default"])('colors.pink'), (0, _themeGet["default"])('colors.smoke'), (0, _themeGet["default"])('colors.darkSmoke'), (0, _themeGet["default"])('colors.extraDarkSmoke'), (0, _themeGet["default"])('colors.pink'));

exports.Container = Container;